import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { atom, useRecoilState, useRecoilValue } from "recoil";
import { getThousandComma } from "../../Api/ApiCommon";
import { GetSubscriptionSetData } from "../../Api/ServiceDatas";
import LineBtn from "../../components/Button/LineBtn";
import ExcelDownload from "../../components/DefaultStyles/ExcelDownload";
import LineBox from "../../components/DefaultStyles/LineBox";
import Loader from "../../components/DefaultStyles/Loader";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import SpaceBetween from "../../components/DefaultStyles/SpaceBetween";
import { OptionType } from "../../components/Filters/DropDown";
import AlertModal from "../../components/Modal/AlertModal";
import MatchingCancelModal from "../../components/pages/Party/MatchingInfo/MatchingCancelModal";
import MatchingInfoFilter from "../../components/pages/Party/MatchingInfo/MatchingInfoFilter";
import Pagination from "../../components/Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../components/Table/Table";
import { useApi } from "../../hooks/useApi";
import { authType } from "../Login";
import { TotalCount } from "../Users/UserInfo";
import { getSubsNameBySubsId3 } from "../../AdminApi/3.0_utils";

export interface IPartyMatching {
  uid: string;
  servsubsid: number;
  edate: string;
  pmax: number;
  pmin: number;
  reqdate: string;
  sdate: string;
  state: number;
  name: string;
  nickname: string;
}

export const matchingFilterState = atom({
  key: "matchingFilterState",
  default: {
    filterType: {
      value: "",
      label: "",
    },
    searchValue: "",
    page: 0,
  },
});

export default function MatchingInfo() {
  const auth = useRecoilValue(authType);
  const navigate = useNavigate();

  const [matchingInfoFilter, setMatchingInfoFilter] = useRecoilState(matchingFilterState);

  const [page, setPage] = useState(matchingInfoFilter?.page ?? 0);

  useEffect(() => {
    setMatchingInfoFilter((prev) => ({ ...prev, page: 0 }));
  }, []);

  const [searchValue, setSearchValue] = useState<string | undefined>(
    matchingInfoFilter?.searchValue !== ""
      ? matchingInfoFilter?.searchValue
      : ""
  );
  const [userDropdownValue, setUserDropdownValue] = useState<OptionType>({
    value:
      matchingInfoFilter?.filterType?.value !== ""
        ? matchingInfoFilter?.filterType?.value
        : "",
    label:
      matchingInfoFilter?.filterType?.label !== ""
        ? matchingInfoFilter?.filterType?.label
        : "선택",
  });
  const [filteringValue, setFilteringValue] = useState({
    isClicked: false,
    servsubsid: "",
    min: 0,
    max: 0,
    today: false,
  });
  const [matchingData, setMatchingData] = useState<IPartyMatching>({
    uid: "",
    servsubsid: 0,
    edate: "",
    pmax: 0,
    pmin: 0,
    reqdate: "",
    sdate: "",
    state: 0,
    name: "",
    nickname: "",
  });
  const [matchingCancelAlertModal, setMatchingCancelAlertModal] =
    useState(false);
  const [matchingCancelModal, setMatchingCancelModal] = useState(false);

  const { response, fetchData, loading } = useApi({
    method: "get",
    url:
      `party/request?page=${page}&size=10` +
      (searchValue !== ""
        ? `&${userDropdownValue?.value}=${searchValue}`
        : ``) +
      (filteringValue?.servsubsid !== ""
        ? `&servsubsid=${filteringValue?.servsubsid}`
        : ``) +
      (filteringValue?.min !== 0
        ? `&min=${filteringValue?.min}&max=${filteringValue?.max}`
        : ``) +
      (filteringValue?.today
        ? `&startdate=${dayjs().format("YYYY-MM-DD")}`
        : ``),
  });

  const tableHead = [
    "NO",
    "UID_이름_닉네임",
    "Subscription",
    "매칭 시작일",
    "매칭 종료일",
    "파티 기간",
    "취소",
  ];

  console.log(auth?.partyCancel);

  return (
    <>
      <PageTitle title="매칭 현황" />

      <MatchingInfoFilter
        setSearchValue={setSearchValue}
        filteringValue={filteringValue}
        setFilteringValue={setFilteringValue}
        userDropdownValue={userDropdownValue}
        setUserDropdownValue={setUserDropdownValue}
        setPage={setPage}
        disabled={response?.data?.items?.length > 0 ? false : true}
      />

      <LineBox>
        <Table tableHeadData={tableHead} tableMinWidth={920}>
          <>
            {response?.data?.items?.map((d: IPartyMatching, index: any) => {
              return (
                <TableBody key={index}>
                  <TableBodyItem>
                    {response?.data?.totalCount - (page * 10 + index)}
                  </TableBodyItem>
                  <TableBodyItem
                    clickable={true}
                                        onClick={() => {
                      setMatchingInfoFilter((prev) => ({ ...prev, page }));
                      navigate(`/users/info/${d?.uid}`);
                    }}
                  >
                    {d?.uid}_{d?.name}_{d?.nickname}
                  </TableBodyItem>
                  <TableBodyItem isKeepAll={true}>
                    {d?.servsubsid}_{getSubsNameBySubsId3(d?.servsubsid)}
                  </TableBodyItem>
                  <TableBodyItem>
                    {dayjs(d?.sdate)?.format("YYYY-MM-DD")}
                  </TableBodyItem>
                  <TableBodyItem>
                    {dayjs(d?.edate)?.format("YYYY-MM-DD")}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.pmin}~{d?.pmax}
                  </TableBodyItem>
                  <TableBodyItem>
                    <LineBtn
                      btnText="취소"
                      btnClickEvent={() => {
                        setMatchingData(d);
                        setMatchingCancelAlertModal(true);
                      }}
                      disabled={!auth?.partyCancel}
                    />
                  </TableBodyItem>
                </TableBody>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      <ExcelDownload />

      {matchingCancelAlertModal && (
        <AlertModal
          title={`${matchingData?.uid}_${matchingData?.name}_${
            matchingData?.nickname
          }님의 
          ${matchingData?.servsubsid}_${getSubsNameBySubsId3(
            matchingData?.servsubsid
          )} 파티 매칭이 취소됩니다. 계속하시겠습니까?
                  `}
          cancelEvent={() => setMatchingCancelAlertModal(false)}
          confirmText="계속"
          confirmEvent={() => {
            setMatchingCancelModal(true);
            setMatchingCancelAlertModal(false);
          }}
        />
      )}

      {matchingCancelModal && (
        <MatchingCancelModal
          cancelEvent={() => {
            setMatchingCancelModal(false);
            fetchData({
              method: "get",
              url:
                `party/request?page=${page}&size=10` +
                (searchValue !== ""
                  ? `&${userDropdownValue?.value}=${searchValue}`
                  : ``) +
                (filteringValue?.servsubsid !== ""
                  ? `&servsubsid=${filteringValue?.servsubsid}`
                  : ``) +
                (filteringValue?.min !== 0
                  ? `&min=${filteringValue?.min}&max=${filteringValue?.max}`
                  : ``),
            });
          }}
          closeEvent={() => {
            setMatchingCancelModal(false);
          }}
          uid={matchingData?.uid}
          servsubsid={matchingData?.servsubsid}
        />
      )}

      {loading && <Loader />}
    </>
  );
}
